import React from 'react';

import StatusDot from 'components/Relatorios/shared/Aprovacao/StatusDot';
import BodyRegular from 'components/Typography/BodyRegular';

import './index.scss';

export interface CalendarioLegendaProps {
  isAdmin: boolean;
}

/**
 * Legenda do calendário de publicação no `ControlPanel` (PLANO v2, T14).
 * Exclusiva do admin: mostra os 3 estados reais (publicado/em_revisao/
 * sem_informe). O cliente não vê legenda — o calendário dele já desabilita
 * (via `filterDate`/`dayClassName`) os dias não publicados.
 */
export default function CalendarioLegenda({ isAdmin }: CalendarioLegendaProps) {
  if (!isAdmin) return null;

  return (
    <div className="relatorio-aprovacao-calendario-legenda">
      <div className="relatorio-aprovacao-calendario-legenda__item">
        <StatusDot status="publicado" />
        <BodyRegular>Aprovado e publicado</BodyRegular>
      </div>
      <div className="relatorio-aprovacao-calendario-legenda__item">
        <StatusDot status="em_revisao" />
        <BodyRegular>Em revisão — acessível só para admin</BodyRegular>
      </div>
      <div className="relatorio-aprovacao-calendario-legenda__item">
        <StatusDot status="sem_informe" />
        <BodyRegular>Futuro / sem informe</BodyRegular>
      </div>
    </div>
  );
}
